import { Helmet } from 'react-helmet'
import MainHeader from '../../../components/MainHeader'
import MainFooter from '../../../components/MainFooter'
import CTAButton from '../../../components/CTAButton.js'
import BackButton from '../../../components/MainComponents.js'

import { motion } from "framer-motion";

import './ServiceHosting.css'
import './MServiceHosting.css'
import { boxvar1, boxvar2, boxvar2_1, boxvar2_2, boxvar2_3, boxvar2dyndelay, boxvar4, oPU } from '../../../core.js'
// import {  } from '@fortawesome/free-solid-svg-icons';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';


export default function ServiceHosting() {

    return (
        <div className='mainCon' id='mainCon'>

            <MainHeader selectedsite={"services"} disableanimation={false} />

            <Helmet>
                <meta charSet="utf-8" />
                <title>ToN - Hosting</title>
                <meta property="og:title" content="Serverhosting" />
                <meta property="og:description" content="Serverhosting nach deinen Bedürfnissen mit unseren starken Partnern" />
                <meta name="description" content="Serverhosting nach deinen Bedürfnissen mit unseren starken Partnern" />
            </Helmet>
            <section className='sec_next' id='sec_next--service-hosting'>
                <div className='sec_next_cont' id="sec_next--service-hosting--cont" style={{ wordBreak: "break-word" }}>
                    <BackButton href='/services' />


                    <motion.div variants={boxvar2_1} className='about_section_cont' initial="hidden" exit="hidden" whileInView="visible" viewport={{ once: false, margin: "-50px" }}>
                        <br />
                        <h2>Rechenpower für deinen Erfolg.</h2>
                        <p>
                            Jede Software braucht auch die passende Hardware, um funktionieren zu können.<br />
                            Wir beraten dich individuell bei der Auswahl des passenden Servers, um all deine Anforderungen zu erfüllen.<br />
                            Für manche Vorhaben ist es besser die Hardware bei sich zu haben, für andere lohnt sich outsourcing an einen externen Hoster.<br />
                            Dafür haben wir den Hostinganbieter <a href='https://prepaid-hoster.de' target='_blank'>PPH Henrik Kramer e.K.</a> als starken und langjährigen Partner.
                        </p>

                        <CTAButton className="" showArrow={true} customIcon={null} iconLeft={false} title={"Jetzt beraten lassen"} onclick={() => { oPU('https://calendly.com/tonetworkde-meet/getintouch') }}></CTAButton>

                    </motion.div>

                    <br /><br />


                    <motion.div variants={boxvar2_1} style={{}} className='' initial="hidden" exit="hidden" whileInView="visible" viewport={{ once: false, margin: "-50px" }}>

                        <h2>Warum wir?</h2>
                        <ul>
                            <li>Wir bieten dir einen Rundum-Service, damit du dich entsptannt auf dein Business konzentrieren kannst</li>
                            <li>Wir stehen dir auch nach Abschluss des Projekts als langjähriger Partner zur Seite</li>
                            <li>Langjährige Erfahrung in der Softwareentwicklung</li>
                            <li>Best Practices = Our Practices</li>
                            <li>Unsere Leistungen sind unabhängig von der Größe deines Projekts</li>
                        </ul>


                    </motion.div>

                    <br /><br /><br /><br />


                    <motion.div variants={boxvar2_1} style={{}} className='' initial="hidden" exit="hidden" whileInView="visible" viewport={{ once: false, margin: "-50px" }}>
                        <h2>Was kostet das?</h2>
                        <p>
                            Eine transparente Preisübersicht findest du auf unserer Preise-Seite. Alle dort genannten Beträge sind <b>Listenpreise ohne Rabatte</b> und werden individuell auf dein Projekt zugeschnitten.
                        </p>
                        <br />
                        <CTAButton className="" showArrow={true} customIcon={null} iconLeft={false} title={"Zu den Preisen"} href={'/pricing'}></CTAButton>
                    </motion.div>

                    <br /><br /><br /><br />

                    <motion.div variants={boxvar2dyndelay} className='small_services_box small_services_box-bigbottom' initial="hidden" exit="hidden" whileInView="visible" custom={0.3} viewport={{ once: false, margin: "-50px" }}>
                        <div className='small_services_textbox'>
                            <h3>&lt;Individuelle Entwicklung und Beratung/&gt;</h3>
                            <br /><br />
                            <p>
                                Du bist bei unseren Leistungen nicht fündig geworden? Wir sind offen für Herausforderungen 😉<br />
                                Wir stehen dir mit Expertise zur Seite und entwickeln bspw. ein Branding für deine Marke, eine Elektronikkomponente oder eine individuelle Softwarelösung für dich.
                            </p>
                            <CTAButton className="" showArrow={true} customIcon={null} iconLeft={false} title={"Jetzt anfragen"} href={'/support'}></CTAButton>
                        </div>
                    </motion.div>

                    <br /><br /><br /><br />
                </div>
            </section >

            <MainFooter />
        </div >
    )
}
